import { constructSameAddressMap } from "../utils/constructSameAddressMap";
import { SupportedChainId } from "./chains";

type AddressMap = { [chainId: number]: string }

export const UNI_ADDRESS: AddressMap = constructSameAddressMap('0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984')
export const MULTICALL_ADDRESS: AddressMap = {
  ...constructSameAddressMap('0x1F98415757620B543A52E61c46B32eB19261F984', [
    SupportedChainId.OPTIMISTIC_KOVAN,
    SupportedChainId.OPTIMISM,
    SupportedChainId.POLYGON_MUMBAI,
    SupportedChainId.POLYGON,
  ]),
  [SupportedChainId.ARBITRUM_ONE]: '0xadF885960B47eA2CD9B55E6DAc6B42b7Cb2806dB',
  [SupportedChainId.ARBITRUM_RINKEBY]: '0xa501c031958F579dB7676fF1CE78AD305794d579',
  [SupportedChainId.ALFAJORES]: '0x3448011cbd2c0dB6E969151099f7d03c8f637B94',
  [SupportedChainId.AURORA_TEST]: '0x976F3870780373c1644cBd8b5a841eF7bd582fe7',
}
export const V2_FACTORY_ADDRESSES = {
  [SupportedChainId.MAINNET]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.OPTIMISM]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.OPTIMISTIC_KOVAN]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ARBITRUM_ONE]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ARBITRUM_RINKEBY]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.POLYGON_MUMBAI]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.POLYGON]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ALFAJORES]: {
    "ubeswap": '0x62d5b84bE28a183aBB507E125B384122D2C25fAE',
    "uniswapv3": "0xAfE208a311B21f13EF87E33A90049fC17A7acDEc"
  },
  [SupportedChainId.AURORA_TEST]: {
    "trisolaris": '0x60913758635b54e6C9685f92201A5704eEe74748',
  },
  [SupportedChainId.GOERLI]: {
    "sushiswap": '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    "uniswapv2": '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f'
  },
}

export const V2_ROUTER_ADDRESS: AddressMap = constructSameAddressMap('0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506') //this could be wrong since it is Sushi only! maybe not really being used in the code?
export const V3_ROUTER_ADDRESS: AddressMap = constructSameAddressMap('0xE592427A0AEce92De3Edee1F18E0157C05861564', [
  SupportedChainId.OPTIMISM,
  SupportedChainId.OPTIMISTIC_KOVAN,
  SupportedChainId.ARBITRUM_ONE,
  SupportedChainId.ARBITRUM_RINKEBY,
  SupportedChainId.POLYGON,
  SupportedChainId.POLYGON_MUMBAI,
])
export const SWAP_ROUTER_ADDRESSES: AddressMap = constructSameAddressMap('0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45', [
  SupportedChainId.OPTIMISM,
  SupportedChainId.OPTIMISTIC_KOVAN,
  SupportedChainId.ARBITRUM_ONE,
  SupportedChainId.ARBITRUM_RINKEBY,
  SupportedChainId.POLYGON,
  SupportedChainId.POLYGON_MUMBAI,
])

/**
 * The oldest V0 governance address
 */
export const GOVERNANCE_ALPHA_V0_ADDRESSES: AddressMap = constructSameAddressMap(
  '0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F'
)
/**
 * The older V1 governance address
 */
export const GOVERNANCE_ALPHA_V1_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '0xC4e172459f1E7939D522503B81AFAaC1014CE6F6',
}

//Double smart contract remove the need to havce the INIT_CODE_HASH!
export const INIT_CODE_HASH = {
  [SupportedChainId.MAINNET]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.OPTIMISM]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.OPTIMISTIC_KOVAN]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ARBITRUM_ONE]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ARBITRUM_RINKEBY]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.POLYGON_MUMBAI]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.POLYGON]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.GOERLI]: {
    "sushiswap": '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
    "uniswapv2": '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f'
  },
  [SupportedChainId.ALFAJORES]: {
    "ubeswap": '0xb3b8ff62960acea3a88039ebcf80699f15786f1b17cebd82802f7375827a339c',
    "uniswapv3": '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f',
  },
  [SupportedChainId.AURORA_TEST]: {
    "trisolaris": '0x754e1d90e536e4c1df81b7f030f47b4ca80c87120e145c294f098c83a6cb5ace',
  }
}
/**
 * The latest governor bravo that is currently admin of timelock
 */
export const GOVERNANCE_BRAVO_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '0x408ED6354d4973f66138C91495F2f2FCbd8724C3',
}

export const TIMELOCK_ADDRESS: AddressMap = constructSameAddressMap('0x1a9C8182C09F50C8318d769245beA52c32BE35BC')

export const MERKLE_DISTRIBUTOR_ADDRESS: AddressMap = {
  [SupportedChainId.MAINNET]: '0x090D4613473dEE047c3f2706764f49E0821D256e',
}
export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {
  [SupportedChainId.MAINNET]: '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8',
}

export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
  [SupportedChainId.OPTIMISM]: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
  [SupportedChainId.OPTIMISTIC_KOVAN]: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
  [SupportedChainId.ARBITRUM_ONE]: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
  [SupportedChainId.ARBITRUM_RINKEBY]: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
  [SupportedChainId.POLYGON_MUMBAI]: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
  [SupportedChainId.POLYGON]: "0x1F98431c8aD98523631AE4a59f267346ea31F984",
  [SupportedChainId.CELO]: "0xAfE208a311B21f13EF87E33A90049fC17A7acDEc",
  [SupportedChainId.ALFAJORES]: "0xAfE208a311B21f13EF87E33A90049fC17A7acDEc",
}

export const QUOTER_ADDRESSES: AddressMap = constructSameAddressMap('0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6', [
  SupportedChainId.OPTIMISM,
  SupportedChainId.OPTIMISTIC_KOVAN,
  SupportedChainId.ARBITRUM_ONE,
  SupportedChainId.ARBITRUM_RINKEBY,
  SupportedChainId.POLYGON_MUMBAI,
  SupportedChainId.POLYGON,
])

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  [SupportedChainId.OPTIMISM]: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  [SupportedChainId.OPTIMISTIC_KOVAN]: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  [SupportedChainId.ARBITRUM_ONE]: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  [SupportedChainId.ARBITRUM_RINKEBY]: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  [SupportedChainId.POLYGON_MUMBAI]: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  [SupportedChainId.POLYGON]: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  [SupportedChainId.ALFAJORES]: '0x3d79EdAaBC0EaB6F08ED885C05Fc0B014290D95A',
  [SupportedChainId.AURORA]: '0x94f9FD7CFd22C5FDde68e30F0D6D122B7d598839',
  [SupportedChainId.GOERLI]: '0x15d614D8B82Ebc1A0e5f2bf0D41CfFa3843Db23c',
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
  [SupportedChainId.GOERLI]: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
  [SupportedChainId.ALFAJORES]: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
}
export const SOCKS_CONTROLLER_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '0x65770b5283117639760beA3F867b69b3697a91dd',
}

export const ASSET_VAULT_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '0x7a88E4Dc7FF9e61C1Ebb20A692c3e598D6A8B875',
  [SupportedChainId.OPTIMISM]: '0x7a88E4Dc7FF9e61C1Ebb20A692c3e598D6A8B875',
  [SupportedChainId.OPTIMISTIC_KOVAN]: '0x7a88E4Dc7FF9e61C1Ebb20A692c3e598D6A8B875',
  [SupportedChainId.ARBITRUM_ONE]: '0x7a88E4Dc7FF9e61C1Ebb20A692c3e598D6A8B875',
  [SupportedChainId.ARBITRUM_RINKEBY]: '0x7a88E4Dc7FF9e61C1Ebb20A692c3e598D6A8B875',
  [SupportedChainId.POLYGON_MUMBAI]: '0x7a88E4Dc7FF9e61C1Ebb20A692c3e598D6A8B875',
  [SupportedChainId.POLYGON]: '0x7a88E4Dc7FF9e61C1Ebb20A692c3e598D6A8B875',
  [SupportedChainId.ALFAJORES]: '0x8E8b2C744269e8584a3591988c0e975E29C09F84',
  [SupportedChainId.AURORA]: '0x94f9FD7CFd22C5FDde68e30F0D6D122B7d598839',
  [SupportedChainId.GOERLI]: '0x15d614D8B82Ebc1A0e5f2bf0D41CfFa3843Db23c',
}

export const AMM_VAULT_ADDRESSES = {
  [SupportedChainId.MAINNET]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.OPTIMISM]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.OPTIMISTIC_KOVAN]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ARBITRUM_ONE]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ARBITRUM_RINKEBY]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.POLYGON_MUMBAI]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.POLYGON]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.GOERLI]: {
    "sushiswap": '0x0CE866498B970C347B8b6Af2824485ccd64d7976',
    "uniswapv2": '0x684025fc6735ddC30704027f781828B838966Cd3',
    "uniswapv3": '0x3811Fcda0EBa567Ed60Fb2e9EcB2B08622BEe5b7',
  },
  [SupportedChainId.ALFAJORES]: {
    "ubeswap": '0xc8F1A0661e778FdE8A89e5e0CC666A5b9CbCC6Ad',
    "uniswapv3": '0xf68a5bDE5e0Be3F71585ce55d1CcFec2EBD9a585',
  },
  [SupportedChainId.AURORA_TEST]: {
    "trisolaris": '0xFc695d262bA0480726b9F2427C34Ad0a4e06CbF4',
  }
}

export const LP_MIGRATOR_ADDRESSES = {
  [SupportedChainId.MAINNET]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.OPTIMISM]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.OPTIMISTIC_KOVAN]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ARBITRUM_ONE]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.ARBITRUM_RINKEBY]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.POLYGON_MUMBAI]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.POLYGON]: {
    "sushiswap": '',
    "uniswapv2": '',
    "trisolaris": '',
    "pancakeswap": ''
  },
  [SupportedChainId.GOERLI]: {
    "sushiswap": '0x81e9B24312D897A848dA64bBe8e46dffA8797F72',
    "uniswapv2": '0xe8e4d00b2FB15a7CEABac8c860EA2F2F362757b2',
    // "uniswapv3": '0x17c2E8C296b6A5118753FCefdBF1B2cf9A34eaC3',
  },
  [SupportedChainId.ALFAJORES]: {
    "ubeswap": '0xEF49d9B8506afb43fA54A521367eE8405F1F2ca8',
    "uniswapv3": '0x4104aa93a07d5850A79539dBA5404AC3Ba5bdb21',
  },
  [SupportedChainId.AURORA_TEST]: {
    "trisolaris": '0x57340f94D88E1e44A72E68673c40250B45822090',
  }
}

export const REWARD_STORAGE_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '',
  [SupportedChainId.GOERLI]: '',
  [SupportedChainId.ALFAJORES]: '0xd8731a7744239dE0400AC8d73057339814550302',
}

export const CLUB_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '',
  [SupportedChainId.GOERLI]: '',
  [SupportedChainId.ALFAJORES]: '0x6340CdDdC48347b637e909Db574485A649037205',
}

export const DOUBLE_DOWN_CLUB_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '',
  [SupportedChainId.GOERLI]: '',
  [SupportedChainId.ALFAJORES]: '0x3EA59d0BD7D21BE17565Ef367eF8966d66D4f5db',
}

export const DDJ_ADDRESSES: AddressMap = {
  [SupportedChainId.MAINNET]: '',
  [SupportedChainId.GOERLI]: '',
  [SupportedChainId.ALFAJORES]: '0xc7078359Da62753e80D2B581F865c237112C9963',
}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.ARBITRUM_ONE]: '0xbfd8137f7d1516D3ea5cA83523914859ec47F573',
  [SupportedChainId.ARBITRUM_RINKEBY]: '0xbfd8137f7d1516D3ea5cA83523914859ec47F573',
  [SupportedChainId.ALFAJORES]: '0x5f115D9113F88e0a0Db1b5033D90D4a9690AcD3D'
}
